export const TEST_ID_SAVED_TOURIST_MOBILE_MENU_TITLE =
  'TEST_ID_SAVED_TOURIST_MOBILE_MENU_TITLE';
